import {
  Icon,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableComponent, {
  StyledTableCell,
  StyledTableRow,
} from "../../components/Table";
import { Row } from "../../components/StyledGridSystem";
import { Col } from "../../components/StyledGridSystem";

import styled from "styled-components";
import { SelectAnnouncementModal } from "./SelectAnnouncementModal";
import React, { useEffect, useMemo, useState, useContext } from "react";
import axios from "axios";
import format from "date-fns/format";
import { endOfMonth, lastDayOfMonth, startOfMonth, subMonths } from "date-fns";
import { FlexGrow } from "../../components/FlexBox";
import { useScreenClass } from "react-grid-system";
import Icon1 from "../../components/Icon";
import { UserContext } from "../../context/UserContext";
import { CreateAnnoucementModal } from "./CreateModal";
import { EndSelect, StartSelect } from "../../components/MonthSelect";
import Button from "../../components/Button";
import { UpdateModal } from "./UpdateModal";
import ConfirmModal from "../../components/ConfirmModal";
import SnackBar from "../../components/SnackBar";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import { StyleElements } from "../RoadMap/StudentTimelines";
import MinimalSelect from "../../components/MinimalSelect";
import { UniversityContext } from "../../context/UniversityContext";

export const AnnouncementPage = () => {
  const CustomRow = styled(Row)`
    margin-bottom: 0px;
    height: calc(100vh - 84px);
    height: -moz-calc(100vh - 84px);
    height: -o-calc(100vh - 84px);
    height: -webkit-calc(100vh - 84px);
  `;
  const StyledAddButton = styled(Button)`
    margin-right: 24px;
    background: linear-gradient(270deg, #3a84ee 0%, #1a5edf 100%);
    height: 39px;
    backdrop-filter: blur(44px);
    padding: 6px 12px;
    border-radius: 6px;
    &:hover:not(:disabled) {
      background-color: linear-gradient(270deg, #3a84ee 0%, #1a5edf 100%);
    }
  `;
  type iconProps = {
    hoverColor: string;
    color: string;
  };
  const StyledIcon = styled.span<iconProps & React.HTMLProps<HTMLDivElement>>`
    title: "edit";
    color: ${({ color }) => color || "white"};
    &:hover {
      background-color: linear-gradient(270deg, #3a84ee 0%, #1a5edf 100%);
      color: ${({ hoverColor }) => hoverColor || "white"};
    }
  `;

  const screenClass = useScreenClass();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState<any>();
  const [announcementData, setAnnoucenmentData] = useState<Array<any>>();
  const [openAddAnnouncement, setOpenAddAnnoucement] = useState<boolean>(false);
  const [updateModalOpen, setUpdateModalOpen] = useState<boolean>(false);
  const { user } = useContext(UserContext);

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );

  // Filter objects with pinned: true
  const pinnedObjects = announcementData?.filter(
    (item) => item.pinned === true
  )[0];
  const today = new Date();
  const firstDateOfMonth = startOfMonth(today);
  const universityContext = useContext(UniversityContext);

  //for default (3 months data)
  const twoMonthsAgo = format(subMonths(firstDateOfMonth, 2), "yyyy-MM-dd");
  const endOfThisMonth = format(endOfMonth(today), "yyyy-MM-dd");
  const [startMonth, setStartMonth] = useState<string>(twoMonthsAgo);
  const [endMonth, setEndMonth] = useState<string>(endOfThisMonth);
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  const [isMessageOpen, setIsMessageOpen] = useState<boolean>(false);
  const [messageHeader, setMessageHeader] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [messageType, setMessageType] =
    useState<"error" | "success" | "warning" | "info">("info");

  const [deleteId, setDeleteId] = useState<any>();

  const fetchAnnouncement = () => {
    setAnnoucenmentData([]);

    const programParam =
      (universityContext.selectedProgram.program_abbrev === "ALL" || universityContext.selectedProgram.value === "ALL") && user.role !== 1
        ? ""
        : `&program_name=${
            user.programs?.[0]?.program_name ||
            universityContext?.selectedProgram?.label
          }`;
    axios
      .get(
        `/announcement?start_date=${startMonth}&end_date=${endMonth}&university_code=${user.university_code}${programParam}`
      )
      .then((res) => {
        setAnnoucenmentData(res.data.announcements.reverse());
      })
      .catch((err) => {
        handleJWTError(err);
        console.log(err);
      });
  };
  useEffect(() => {
    fetchAnnouncement();
  }, [startMonth, endMonth, universityContext?.selectedProgram]);

  useEffect(() => {
    // universityContext.setProgram(universityContext?.programs?.[0]);
    universityContext.setProgram({
      label: "ALL Programs",
      value: "ALL",
      degree_abbrev: "",
      program_abbrev: "ALL",
      id: "",
      description: "",
      first_semester: "",
      program_name: "All Programs",
      short_name: "",
      university_code: "",
      versions: [],
    });
  }, []);

  const setAnnouncementModalData = (open: boolean, data: any) => {
    setIsModalOpen(open);
    setSelectedAnnouncement(data);
  };

  const updateModal = (e: any, open: boolean, data: any) => {
    e.stopPropagation();
    setUpdateModalOpen(open);
    setSelectedAnnouncement(data);
  };
  const _handleConfirm = (e: any, id: string) => {
    e.stopPropagation();
    setDeleteId(id);
    setConfirmDelete(true);
  };
  const deleteAnnouncement = () => {
    axios
      .delete(
        `/announcement/delete?announcement_id=${deleteId}&email=${user.email}`
      )
      .then((res) => {
        fetchAnnouncement();
        setConfirmDelete(false);
        setMessageType("success");
        setMessageHeader("Deleted!");
        setMessage("Announcement has been removed!");
        setIsMessageOpen(true);
      })
      .catch((error) => {
        handleJWTError(error);
        setMessageType("error");
        setMessageHeader("Failed!");
        setMessage(error.response.data.error);
        setIsMessageOpen(true);
        setConfirmDelete(false);
      });
  };

  return (
    <>
      {selectedAnnouncement && (
        <SelectAnnouncementModal
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
          setAnnouncement={setSelectedAnnouncement}
          announcement={selectedAnnouncement}
        />
      )}
      {openAddAnnouncement && (
        <CreateAnnoucementModal
          setMessage={setMessage}
          setMessageHeader={setMessageHeader}
          setMessageType={setMessageType}
          setIsMessageOpen={setIsMessageOpen}
          fetchAnnouncement={fetchAnnouncement}
          isMobile={isMobile}
          setOpen={setOpenAddAnnoucement}
          isOpen={true}
        />
      )}
      {updateModalOpen && (
        <UpdateModal
          setMessage={setMessage}
          setMessageHeader={setMessageHeader}
          setMessageType={setMessageType}
          setIsMessageOpen={setIsMessageOpen}
          announcement={selectedAnnouncement}
          setAnnouncement={setSelectedAnnouncement}
          fetchAnnouncement={fetchAnnouncement}
          isMobile={isMobile}
          setOpen={setUpdateModalOpen}
          isOpen={updateModalOpen}
        />
      )}
      <ConfirmModal
        title="Delete Announcement"
        description={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon
              title="Required for graduation"
              sx={{
                color: "yellow",
                paddingRight: "5px",
                // boxShadow: "0 4px 4px #0000007a",
              }}
            >
              warning
            </Icon>
            Are you sure you want to delete this announcement?
          </div>
        }
        setOpen={setConfirmDelete}
        isOpen={confirmDelete}
        confirmFunction={() => {
          deleteAnnouncement();
        }}
      />
      <SnackBar
        isOpen={isMessageOpen}
        setOpen={setIsMessageOpen}
        header={messageHeader}
        message={message}
        type={messageType}
        style={{zIndex:99999999}}
      />
      <FlexGrow
        style={{
          flexGrow: 0,
          display: "flex",
          alignItems: "center",
          position: "absolute",
          top: -42,
          zIndex: 1000,
        }}
      >
        <StartSelect
          startMonth={startMonth}
          setStartMonth={setStartMonth}
          endMonth={endMonth}
          setEndMonth={setEndMonth}
        />
        <span style={{ paddingLeft: 10, paddingRight: 10 }}> to </span>
        <EndSelect
          startMonth={startMonth}
          setStartMonth={setStartMonth}
          endMonth={endMonth}
          setEndMonth={setEndMonth}
        />
        {user.role !== 1 && (
          <StyleElements>
            <MinimalSelect
              setClass={"custom-container"}
              // setClass={"rs-container"}
              required
              placeholder="Program"
              options={[
                ...(universityContext.programs || []),
                { label: "ALL Programs", value: "ALL" },
              ]}
              value={
                universityContext.programs?.find(
                  (v: any) =>
                    v.short_name ===
                    universityContext.selectedProgram?.short_name
                ) || { label: "ALL Programs", value: "ALL" }
              }
              onChange={(newValue: any) => {
                universityContext.setProgram(newValue);
              }}
            />
          </StyleElements>
        )}
        {user.role !== 1 && (
          <StyledAddButton
            style={{ whiteSpace: "nowrap" }}
            onClick={() => {
              setOpenAddAnnoucement(true);
            }}
          >
            {!isMobile && window.screen.width > 1140 ? (
              <>
                <Icon1
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="plus-circle"
                />
                Add Announcement
              </>
            ) : (
              <>
                <Icon1
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  name="plus-circle"
                />
              </>
            )}
          </StyledAddButton>
        )}
      </FlexGrow>

      <CustomRow
        wrap="nowrap"
        style={{ marginLeft: "-12px", marginRight: "-10px" }}
      >
        <Col style={{ padding: 0 }}>
          <TableComponent>
            {/* <TableContainer component={Paper}>
        <Table sx={{ background: "#0f1123" }} aria-label="simple table"> */}
            <TableHead>
              <TableRow>
                <StyledTableCell
                  style={{
                    width: 10,
                    fontWeight: "bold",
                    borderBottom: "1px solid #3C406C",
                  }}
                ></StyledTableCell>
                <StyledTableCell
                  style={{
                    minWidth: 90,
                    fontWeight: "bold",
                    borderBottom: "1px solid #3C406C",
                  }}
                >
                  Posted Date
                </StyledTableCell>
                <StyledTableCell
                  style={{
                    width: 200,
                    overflow: "scroll",
                    fontWeight: "bold",
                    borderBottom: "1px solid #3C406C",
                  }}
                >
                  Title
                </StyledTableCell>
                <StyledTableCell
                  style={{
                    minWidth: 100,
                    fontWeight: "bold",
                    borderBottom: "1px solid #3C406C",
                  }}
                >
                  Category
                </StyledTableCell>

                <StyledTableCell
                  style={{
                    minWidth: 100,
                    fontWeight: "bold",
                    borderBottom: "1px solid #3C406C",
                  }}
                >
                  Creator
                </StyledTableCell>
                <StyledTableCell
                  // key={column.id}
                  style={{
                    minWidth: 100,
                    fontWeight: "bold",
                    borderBottom: "1px solid #3C406C",
                  }}
                >
                  URL
                </StyledTableCell>
                {user.role !== 1 && (
                  <StyledTableCell
                    // key={column.id}
                    style={{
                      minWidth: 20,
                      fontWeight: "bold",
                      borderBottom: "1px solid #3C406C",
                    }}
                  ></StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {pinnedObjects && (
                <TableRow
                  onClick={() => {
                    setAnnouncementModalData(true, pinnedObjects);
                  }}
                  style={{
                    background: "linear-gradient(to right,#1E40AF,#0000)",

                    boxShadow: "0 1px 10px #000000",
                    cursor: "pointer",
                  }}
                >
                  <StyledTableCell
                    style={{
                      borderBottomLeftRadius: 5,
                      borderBottom: "1px solid #474747",
                    }}
                  >
                    <Icon
                      sx={{
                        color: "#ffff86",
                        mr: 1,
                        textShadow: "0 1px 5px black",
                        transform: "rotate(45deg)",
                        fontSize: "20px",
                      }}
                    >
                      push_pin
                    </Icon>
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ borderBottom: "1px solid #474747" }}
                  >
                    {pinnedObjects?.date_created}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      borderBottom: "1px solid #474747",
                      maxWidth: 200,
                      overflowX: "auto",
                    }}
                    className="visible-scrollbar"
                  >
                    {pinnedObjects?.title}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ borderBottom: "1px solid #474747", maxWidth: 200 }}
                  >
                    {pinnedObjects?.announcement_category}
                  </StyledTableCell>

                  <StyledTableCell
                    style={{ borderBottom: "1px solid #474747" }}
                  >
                    {pinnedObjects?.creator}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      borderBottom: "1px solid #474747",
                      maxWidth: 200,
                      overflowX: "auto",
                    }}
                    className="visible-scrollbar"
                  >
                    {pinnedObjects?.url}
                  </StyledTableCell>
                  {user.role !== 1 && (
                    <StyledTableCell
                      style={{
                        maxWidth: 50,
                        minWidth: 50,
                        borderLeft: "1px solid #3c406c52",
                        position: "sticky",
                        background: "#0f1123",
                        right: 0,
                      }}
                    >
                      <StyledIcon
                        hoverColor="white"
                        color="gray"
                        onClick={(e) => updateModal(e, true, pinnedObjects)}
                      >
                        <Icon
                          sx={{
                            textShadow: "0 1px 5px black",
                            fontSize: "20px",
                          }}
                        >
                          edit
                        </Icon>
                      </StyledIcon>
                      <StyledIcon
                        hoverColor="red"
                        color="#ff9393"
                        onClick={(e: any) =>
                          _handleConfirm(e, pinnedObjects.id)
                        }
                      >
                        <Icon
                          sx={{
                            textShadow: "0 1px 5px black",
                            fontSize: "20px",
                          }}
                        >
                          delete_outline
                        </Icon>
                      </StyledIcon>
                    </StyledTableCell>
                  )}
                </TableRow>
              )}

              {announcementData?.map(
                (d1, k1) =>
                  !d1.pinned && (
                    <React.Fragment key={`announcement-${k1}`}>
                      {k1 !== 0 &&
                        d1.date_created?.substr(5, 2) !==
                          announcementData[k1 - 1]?.date_created.substr(
                            5,
                            2
                          ) && (
                          <TableRow
                            className="visible-scrollbar"
                            style={{
                              background:
                                "linear-gradient(90deg, #2c0c0c 0%, rgb(24, 75, 104) 118.29%)",
                            }}
                          >
                            <TableCell
                              style={{
                                padding: 5,
                                borderBottom: "1px solid #3C406C",
                              }}
                              colSpan={7}
                            ></TableCell>
                          </TableRow>
                        )}
                      <StyledTableRow
                        className="visible-scrollbar"
                        key={k1}
                        onClick={() => {
                          setAnnouncementModalData(true, d1);
                        }}
                      >
                        <StyledTableCell></StyledTableCell>
                        <StyledTableCell>{d1.date_created}</StyledTableCell>
                        <StyledTableCell
                          className="visible-scrollbar"
                          style={{ maxWidth: 200, overflowX: "auto" }}
                        >
                          {d1.title}
                        </StyledTableCell>
                        <StyledTableCell>
                          {d1.announcement_category}
                        </StyledTableCell>

                        <StyledTableCell>{d1.creator}</StyledTableCell>
                        <StyledTableCell
                          className="visible-scrollbar"
                          style={{ maxWidth: 200, overflowX: "auto" }}
                        >
                          {d1.url}
                        </StyledTableCell>
                        {user.role !== 1 && (
                          <StyledTableCell
                            style={{
                              maxWidth: 50,
                              minWidth: 50,
                              borderLeft: "1px solid #3c406c52",
                              position: "sticky",
                              background: "#0f1123",
                              right: 0,
                            }}
                          >
                            <StyledIcon
                              hoverColor="white"
                              color="gray"
                              onClick={(e) => updateModal(e, true, d1)}
                            >
                              <Icon
                                sx={{
                                  textShadow: "0 1px 5px black",
                                  fontSize: "20px",
                                }}
                              >
                                edit
                              </Icon>
                            </StyledIcon>
                            <StyledIcon
                              hoverColor="red"
                              color="#ff9393"
                              onClick={(e: any) => _handleConfirm(e, d1.id)}
                            >
                              <Icon
                                sx={{
                                  textShadow: "0 1px 5px black",
                                  fontSize: "20px",
                                }}
                              >
                                delete_outline
                              </Icon>
                            </StyledIcon>
                          </StyledTableCell>
                        )}
                      </StyledTableRow>
                    </React.Fragment>
                  )
              )}
            </TableBody>
          </TableComponent>
        </Col>
      </CustomRow>
      {/* </Table>
      </TableContainer> */}
    </>
  );
};
